import { render, staticRenderFns } from "./Hints.vue?vue&type=template&id=3988ea5e&scoped=true&"
import script from "./Hints.vue?vue&type=script&lang=js&"
export * from "./Hints.vue?vue&type=script&lang=js&"
import style0 from "./Hints.vue?vue&type=style&index=0&id=3988ea5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3988ea5e",
  null
  
)

export default component.exports